// Auto-generated file - DO NOT EDIT
export const VERSION = '0.9.1265';
export const BUILD_DATE = '2026-10-22T04:00:43.201Z';
export const BUILD_TIMESTAMP = 1792641643201;
